import React, { useState, useEffect } from "react";
import moment from "moment";
import _ from 'lodash';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { DateRangePicker, DateRangeDelimiter } from "@material-ui/pickers";
import {
  withStyles,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import * as Var from "styles/variables";
import {
  setDateRangePicTreeNttFt,
  setDateRangePicTreeCommon,
  getHomePictreePhotoShootCommon,
  getPictreeDataPhotoShootTrendCommon,
  getPictreePhotoShootByAssetCommon,
  getPictreePhotoShootTrendByAssetCommon,
  getByAreaDataCommon,
  getHomePictreeCheckInCommon,
  getPictreeDataCheckInTrendCommon,
  getHomePictreeCheckInNttFt,
  getHomePictreePhotoShootNttFt,
  getPictreeDataCheckInTrendNttFt,
  getPictreeDataPhotoShootTrendNttFt,
  getPictreeDataPhotoDenchuKaisuTrend,
  getInGameItemSalesByOccurrence,
  getPhotoShootMapDataNttFt,
  getPictreePhotoShootByAssetNttFt,
  getPictreePhotoShootTrendByAssetNttFt,
  getHomePictreeReportStats,
  getPictreeDataReportTrend,
  getPictreeDataReportByUser,
  getByAreaData,
  getBudgetSummaryData,
  getBudgetRemainTrendData,
  getBudgetBoostData,
  getBudgetBoostSourceData,
} from "actions";
import PeriodCommon from "components/PicTree/Filter/PeriodCommon";

const useStyles = makeStyles((theme) =>
  createStyles({
    calendarWrapper: {
      paddingLeft: 8,
      flexGrow: 1,
    },
    root: {
      backgroundColor: "#fafafa",
      zIndex: 1000,
      paddingTop: 16,
      paddingLeft: 8,
      marginTop: -12,
    },
    container: {
      display: "flex",
      width: 300,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      alignItems: "baseline",
    },
    delimiter: {
      paddingTop: theme.spacing(1),
    },
    dataBtn: {
      marginTop: theme.spacing(1.2),
      marginLeft: theme.spacing(1),
      height: theme.spacing(4),
      color: Var.btnLabelColor,
    },
    grow: {
      flexGrow: 1,
    },
    sectionCalendar: {
      display: "flex",
      marginRight: theme.spacing(1),
      alignItems: "center",
      gap: theme.spacing(0.5),
    },
    picTreePredefined: {
      marginRight: 16,
      marginTop: -16,
    }
  })
);

const CalendarRangePicTreeCommon = ({
  page,
  singlePeriod,
  dateRangePicTreeCommon,
  dateRangePicTreeMinMax,
  currentPage,
  getHomePictreeCheckInNttFt,
  getHomePictreePhotoShootNttFt,
  getPictreeDataCheckInTrendNttFt,
  getPictreeDataPhotoShootTrendNttFt,
  pictreeChartSize,
  getPhotoShootMapDataNttFt,
  pictreeMapType,
  setDateRangePicTreeNttFt,
  getHomePictreePhotoShootCommon,
  getPictreeDataPhotoShootTrendCommon,
  getPictreePhotoShootByAssetCommon,
  getPictreePhotoShootTrendByAssetCommon,
  getByAreaDataCommon,
  getHomePictreeCheckInCommon,
  getPictreeDataCheckInTrendCommon,
  getPictreePhotoShootByAssetNttFt,
  getPictreePhotoShootTrendByAssetNttFt,
  getHomePictreeReportStats,
  getPictreeDataReportTrend,
  getPictreeDataReportByUser,
  getByAreaData,
  getBudgetSummaryData,
  getBudgetRemainTrendData,
  getBudgetBoostData,
  getBudgetBoostSourceData,
  selectedSeason,
  selectedAreaLayerId,
}) => {
  const classes = useStyles();
  const [dateRangeValue, setDateRangeValue] = useState([null, null]);
  const [error, setError] = useState([null, null]);
  const [minDate, setMinDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);

  const today = moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
  const todayFormatted = moment(today).format("YYYY-MM-DD");

  useEffect(() => {
    const currentJstDate = moment().tz("Asia/Tokyo").format("YYYY/MM/DD");
    handleHomeCalendar(currentJstDate);
  }, []);

  useEffect(() => {
    if (dateRangePicTreeMinMax.length > 0) {
      const defaultMaxDateFormatted = moment(dateRangePicTreeMinMax[1]).format('YYYY-MM-DD');
      const isEndDateAfterToday = moment(today).isBefore(defaultMaxDateFormatted);
      setMinDate(dateRangePicTreeMinMax[0]);
      setMaxDate(isEndDateAfterToday ? todayFormatted : dateRangePicTreeMinMax[1]);
    } else {
      setMinDate(null);
      setMaxDate(null);
    }
  }, [dateRangePicTreeMinMax]);

  useEffect(() => {
    const isEndDateAfterToday = moment(today).isBefore(dateRangePicTreeCommon[1]);
    const dateRangeValue = isEndDateAfterToday ? [dateRangePicTreeCommon[0], todayFormatted] : dateRangePicTreeCommon;
    setDateRangeValue(dateRangeValue);
  }, [dateRangePicTreeCommon]);

  const handleHomeCalendar = (currentJstDate) => {
    setDateRangeValue(dateRangePicTreeCommon);
  };

  const setRange = (newValue) => {
    if (!newValue[0] || !newValue[1]) {
      return;
    }
    const startDate = moment(newValue[0]).format("YYYY-MM-DD");
    const endDate = moment(newValue[1]).format("YYYY-MM-DD");
    setDateRangePicTreeCommon([startDate, endDate]);
    setDateRangeValue([startDate, endDate]);
  };

  const fetchData = () => {
    if (currentPage === "/game/pictree/common/checkin") {
      const selectedRange = dateRangeValue;
      getHomePictreeCheckInCommon({ dateRange: selectedRange });
      getPictreeDataCheckInTrendCommon({
        chartSize: pictreeChartSize,
        dateRange: selectedRange,
      });
    } else if (currentPage === "/game/pictree/common/photos/overview") {
      const selectedRange = dateRangeValue;
      getHomePictreePhotoShootCommon({ dateRange: selectedRange });
      getPictreeDataPhotoShootTrendCommon({ chartSize: pictreeChartSize, dateRange: selectedRange });
    } else if (currentPage === "/game/pictree/common/photos/map") {
      getPhotoShootMapDataNttFt({ type: "denchu", filter: pictreeMapType });
    } else if (currentPage === "/game/pictree/common/photos/asset-type") {
      const selectedRange = dateRangeValue;
      getPictreePhotoShootByAssetCommon({ dateRange: selectedRange });
      getPictreePhotoShootTrendByAssetCommon({ chartSize: pictreeChartSize, dateRange: selectedRange });
    } else if (currentPage === "/game/pictree/common/report/overview") {
      getHomePictreeReportStats("common");
      getPictreeDataReportTrend("common");
    } else if (currentPage === "/game/pictree/common/report/report-by-user") {
      getPictreeDataReportByUser("common");
    } else if (currentPage === "/game/pictree/common/photos/by-area") {
      getByAreaDataCommon({ dateRange: dateRangeValue, areaLayerId: selectedAreaLayerId });
    } else if (currentPage === "/game/pictree/common/budget") {
      getBudgetSummaryData({ companyCode: "common" });
      getBudgetRemainTrendData({ companyCode: "common" });
      getBudgetBoostSourceData({ companyCode: "common" });
      getBudgetBoostData({ companyCode: "common" });
    }
  };

  return (
    <div className={classes.calendarWrapper}>
      <div className={classes.root}>
        <div className={classes.sectionCalendar}>
          <div className={classes.picTreePredefined}>
            <PeriodCommon
              singlePeriod
            />
          </div>
          <DateRangePicker
            startText="Start"
            endText="End"
            disableHighlightToday={true}
            showToolbar={false}
            allowSameDateSelection={true}
            minDate={minDate}
            maxDate={maxDate}
            value={dateRangeValue}
            onChange={(newValue) => setRange(newValue)}
            onError={([startReason, endReason], [start, end]) => {
              if (startReason === "invalidRange") {
                setError([null, null]);
                return;
              }
              setError([startReason, endReason]);
            }}
            renderInput={(startProps, endProps) => (
              <div className={classes.container}>
                <TextField
                  id="standard-basic"
                  {...startProps}
                  error={Boolean(error[0])}
                  size="small"
                  disabled={page === "pictree-map" ? true : false}
                  helperText=""
                />
                <DateRangeDelimiter>
                  <span className={classes.delimiter}>~</span>
                </DateRangeDelimiter>
                <TextField
                  id="standard-basic"
                  {...endProps}
                  error={Boolean(error[0])}
                  size="small"
                  disabled={page === "pictree-map" ? true : false}
                  helperText=""
                />
              </div>
            )}
          />
          <Button
            className={classes.dataBtn}
            variant="contained"
            color="primary"
            onClick={() => fetchData()}
            disabled={false}
          >
            GO
          </Button>
        </div>
      </div>
    </div>
  );
};

CalendarRangePicTreeCommon.prototypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  btnStateDataFetch: state.page.btnStateDataFetch,
  dateRangePicTreeCommon: state.page.dateRangePicTreeCommon,
  dateRangePicTreeMinMax: state.page.dateRangePicTreeMinMax,
  currentPage: state.page.currentPage,
  pictreeView: state.pictree.pictreeView,
  pictreeChartSize: state.pictree.chartSize,
  pictreeMapType: state.pictree.mapType,
  selectedSeason: state.pictreeCommon.selectedSeason,
  selectedAreaLayerId: state.pictreeCommon.selectedAreaLayerId,
});

const mapDispatchToProps = (dispatch) => ({
  setDateRangePicTreeNttFt: (param) => dispatch(setDateRangePicTreeNttFt(param)),
  setDateRangePicTreeCommon: (param) => dispatch(setDateRangePicTreeCommon(param)),
  getHomePictreePhotoShootCommon: (param) => dispatch(getHomePictreePhotoShootCommon(param)),
  getPictreeDataPhotoShootTrendCommon: (param) => dispatch(getPictreeDataPhotoShootTrendCommon(param)),
  getPictreePhotoShootByAssetCommon: (param) => dispatch(getPictreePhotoShootByAssetCommon(param)),
  getPictreePhotoShootTrendByAssetCommon: (param) => dispatch(getPictreePhotoShootTrendByAssetCommon(param)),
  getHomePictreeCheckInNttFt: (param) => dispatch(getHomePictreeCheckInNttFt(param)),
  getHomePictreePhotoShootNttFt: (param) => dispatch(getHomePictreePhotoShootNttFt(param)),
  getPictreeDataCheckInTrendNttFt: (param) => dispatch(getPictreeDataCheckInTrendNttFt(param)),
  getPictreeDataPhotoShootTrendNttFt: (param) => dispatch(getPictreeDataPhotoShootTrendNttFt(param)),
  getPictreeDataPhotoDenchuKaisuTrend: (param) => dispatch(getPictreeDataPhotoDenchuKaisuTrend(param)),
  getInGameItemSalesByOccurrence: (param) => dispatch(getInGameItemSalesByOccurrence(param)),
  getPhotoShootMapDataNttFt: (param) => dispatch(getPhotoShootMapDataNttFt(param)),
  getPictreePhotoShootByAssetNttFt: (param) => dispatch(getPictreePhotoShootByAssetNttFt(param)),
  getPictreePhotoShootTrendByAssetNttFt: (param) => dispatch(getPictreePhotoShootTrendByAssetNttFt(param)),
  getHomePictreeReportStats: (param) => dispatch(getHomePictreeReportStats(param)),
  getPictreeDataReportTrend: (param) => dispatch(getPictreeDataReportTrend(param)),
  getPictreeDataReportByUser: (param) => dispatch(getPictreeDataReportByUser(param)),
  getByAreaData: (param) => dispatch(getByAreaData(param)),
  getByAreaDataCommon: (param) => dispatch(getByAreaDataCommon(param)),
  getHomePictreeCheckInCommon: (param) => dispatch(getHomePictreeCheckInCommon(param)),
  getPictreeDataCheckInTrendCommon: (param) => dispatch(getPictreeDataCheckInTrendCommon(param)),
  getBudgetSummaryData: (param) => dispatch(getBudgetSummaryData(param)),
  getBudgetRemainTrendData: (param) => dispatch(getBudgetRemainTrendData(param)),
  getBudgetBoostData: (param) => dispatch(getBudgetBoostData(param)),
  getBudgetBoostSourceData: (param) => dispatch(getBudgetBoostSourceData(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(CalendarRangePicTreeCommon));
